import { LINKS } from "@/components/Nav";

export default function Footer({ onNavigate }) {
  return (
    <footer className="bg-ink text-paper" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 pt-20">
        <div className="grid grid-cols-1 gap-10 border-b border-paper/20 pb-16 md:grid-cols-12">
          <div className="md:col-span-5">
            <span className="font-serif text-2xl font-bold tracking-tight">Crestbridge</span>
            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-goldlight">
              Financial and Strategy Execution
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-paper/60">
              Designing, building and running your India GCC. Finance,
              Governance, Technology, Strategic Execution.
            </p>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-paper/40">
              Sitemap
            </p>
            <div className="mt-4 grid grid-cols-2 gap-2">
              {LINKS.map((l) => (
                <a
                  key={l.id}
                  href={l.id}
                  onClick={(e) => {
                    e.preventDefault();
                    onNavigate(l.id);
                  }}
                  data-testid={`footer-link-${l.id.slice(1)}`}
                  className="text-left font-mono text-xs uppercase tracking-[0.2em] text-paper/70 transition-colors duration-300 hover:text-goldlight"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-paper/40">
              Head Office
            </p>
            <div className="mt-4 space-y-2 font-mono text-xs uppercase tracking-[0.2em] text-paper/70">
              <p className="leading-loose">
                235, Binnamangala, 2nd Floor,
                <br />
                13th Cross Road, Indira Nagar 2nd Stage,
                <br />
                Bengaluru — 560038
              </p>
              <p className="pt-2 text-goldlight">CXO1@cbfse.com</p>
              <p>+91 98844 90132</p>
            </div>
          </div>
        </div>
        <div className="overflow-hidden">
          <p
            className="text-outline-paper select-none whitespace-nowrap py-10 text-center font-serif text-[9vw] font-bold leading-[0.8] tracking-tight"
            data-testid="footer-brand"
          >
            CRESTBRIDGE
          </p>
        </div>
        <div className="flex flex-col items-start justify-between gap-3 border-t border-paper/20 py-6 font-mono text-[10px] uppercase tracking-[0.2em] text-paper/40 md:flex-row md:items-center">
          <p>© 2026 Crestbridge</p>
          <p>Ownership, not outsourcing.</p>
        </div>
      </div>
    </footer>
  );
}
